import { z } from "zod";
import { GeocodePrecisionSchema } from "../geo/geocode.model.js";
export const AddressPayloadSchema = z.object({
    streetAddress: z.string(),
    streetAddress2: z.string().optional(),
    city: z.string(),
    zipCode: z.string(),
    country: z.string().optional(),
    disableGeocoding: z.boolean().optional(),
});
export const AddressSchema = z.object({
    streetAddress: z.string(),
    streetAddress2: z.string().optional(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    geocodeScore: z.number().nullable(),
    // Granularité IGN (#796) — chargée en mémoire depuis #571 mais jetée par les
    // mappers jusqu'à #797 PR3. Nullable : `null` veut dire "inconnu", pas
    // "mauvais" (voir `isReliableGeocode`, docs/context/geocodage.md §1).
    geocodePrecision: GeocodePrecisionSchema.nullable(),
    city: z.string(),
    zipCode: z.string(),
    country: z.string(),
});
//# sourceMappingURL=address.types.js.map